import NBType, { InferType } from '@netbase/nb-type'
import AlertDayOfWeek from '../enums/AlertDayOfWeek'
import DayHourTimeZone from '../enums/DayHourTimeZone'

const DayHourSchema = NBType.object().shape('DayHourSchema', {
  /* @prop */
  days: NBType.array().of(NBType.enum(AlertDayOfWeek)).nullable(),
  /* @prop */
  duration: NBType.number(),
  /* @prop */
  startHour: NBType.number(),
  /* @prop */
  timeZone: NBType.enum(DayHourTimeZone)
  /* END */
})
export default DayHourSchema
export type DayHour = InferType<typeof DayHourSchema>
// RESERVE BELOW
